"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

var _InputLabel = _interopRequireDefault(require("../InputLabel"));

var _FroalaEditor = _interopRequireDefault(require("./froala-react/FroalaEditor"));

require("./package.js");

var _styles2 = require("./styles");

var _RichTextConstants = require("./RichTextConstants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RichText = function RichText(_ref) {
  var _ref$allowedHtmlTags = _ref.allowedHtmlTags,
      allowedHtmlTags = _ref$allowedHtmlTags === void 0 ? _RichTextConstants.defaultAllowedHtmlTags : _ref$allowedHtmlTags,
      _ref$toolbarButtons = _ref.toolbarButtons,
      toolbarButtons = _ref$toolbarButtons === void 0 ? _RichTextConstants.defaultToolbarButtons : _ref$toolbarButtons,
      _ref$toolbarButtonsSM = _ref.toolbarButtonsSM,
      toolbarButtonsSM = _ref$toolbarButtonsSM === void 0 ? _RichTextConstants.defaultToolbarButtonsSM : _ref$toolbarButtonsSM,
      _ref$toolbarButtonsXS = _ref.toolbarButtonsXS,
      toolbarButtonsXS = _ref$toolbarButtonsXS === void 0 ? _RichTextConstants.defaultToolbarButtonsXS : _ref$toolbarButtonsXS,
      _ref$quickInsertButto = _ref.quickInsertButtons,
      quickInsertButtons = _ref$quickInsertButto === void 0 ? ["table", "ul", "ol", "hr"] : _ref$quickInsertButto,
      _ref$scrollableContai = _ref.scrollableContainer,
      scrollableContainer = _ref$scrollableContai === void 0 ? "body" : _ref$scrollableContai,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$quickInsertEnabl = _ref.quickInsertEnabled,
      quickInsertEnabled = _ref$quickInsertEnabl === void 0 ? true : _ref$quickInsertEnabl,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      id = _ref.id,
      helperText = _ref.helperText,
      disabled = _ref.disabled,
      label = _ref.label,
      placeholder = _ref.placeholder,
      required = _ref.required,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onInputChange = _ref.onInputChange,
      secondaryHelperText = _ref.secondaryHelperText,
      _ref$toolbarSticky = _ref.toolbarSticky,
      toolbarSticky = _ref$toolbarSticky === void 0 ? false : _ref$toolbarSticky,
      promptUserForAssetsAsync = _ref.promptUserForAssetsAsync,
      customToolbarButtons = _ref.customToolbarButtons,
      config = _ref.config,
      classes = _ref.classes,
      forceHtmlView = _ref.forceHtmlView,
      onChange = _ref.onChange,
      events = _ref.events;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      editor = _useState2[0],
      setEditor = _useState2[1];

  var node = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (node.current == null) {
      return;
    }
    /* istanbul ignore next */


    var nodeValue = node.current;

    if (typeof nodeValue != "undefined" && nodeValue != null) {
      nodeValue.addEventListener("keyup", function (event) {
        var froala = event.target.closest(".fr-box");

        if (typeof froala != "undefined" && froala != null && froala.classList.contains("fr-code-view")) {
          var copy = froala.cloneNode(true);
          var lineNumbers = copy.getElementsByClassName("CodeMirror-linenumber");

          for (var j = lineNumbers.length - 1; j >= 0; j--) {
            lineNumbers[j].outerHTML = "";
          }

          var _placeholder = froala.getElementsByClassName("fr-placeholder")[0];

          if (typeof _placeholder != "undefined" && _placeholder != null) {
            _placeholder.outerHTML = "";
          }

          froala.getElementsByClassName("fr-element")[0].innerHTML = copy.getElementsByClassName("CodeMirror-code")[0].innerText;
        }
      });
    }
  }, [node]);
  (0, _react.useEffect)(function () {
    if (editor == null) {
      return;
    }

    if (disabled) {
      editor.edit.off();
    } else {
      editor.edit.on();
    }
  }, [disabled, editor]);
  var initEditor = (0, _react.useCallback)(function (editor, disabled) {
    setEditor(editor);
    /* istanbul ignore next */

    if (disabled) {
      editor.edit.off();
    } else {
      editor.edit.on();
    }
    /* istanbul ignore next */


    editor && editor.events.on("drop", function (e) {
      var dt = e.originalEvent.dataTransfer; // Cancelling event only if dropping files into editor.

      if (dt && dt.files && dt.files.length) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, true);
  }, []);
  var focusEditor = (0, _react.useCallback)(function () {
    if (editor == null) {
      return;
    }
    /* istanbul ignore next */


    editor.events.focus();
  }, [editor]);
  var isEmpty = (0, _react.useCallback)(function () {
    if (editor == null) {
      return false;
    }

    return editor.core.isEmpty();
  }, [editor]);
  var onChangeHandler = (0, _react.useCallback)(function (value) {
    onChange({
      target: {
        value: isEmpty() ? "" : value
      }
    });
  }, [isEmpty, onChange]);
  var setEvents = (0, _react.useCallback)(function (disabled, onBlur, onInputChange) {
    var froalaEvents = {
      initialized: function () {
        var _initialized = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1);
                  });

                case 2:
                  initEditor(this, disabled);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function initialized() {
          return _initialized.apply(this, arguments);
        }

        return initialized;
      }(),
      blur: onBlur,
      input: function () {
        var _input = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1);
                  });

                case 2:
                  /* istanbul ignore next */
                  onInputChange && onInputChange(this.html.get());

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function input() {
          return _input.apply(this, arguments);
        }

        return input;
      }()
    };

    if (events && events.length > 0) {
      events.map(function (event) {
        switch (event.eventName) {
          case "initialized":
            return froalaEvents["initialized"] = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 1);
                      });

                    case 2:
                      initEditor(this, disabled);
                      event.eventCallback(this);

                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));

          case "blur":
            return froalaEvents["blur"] = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
              return _regenerator.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 1);
                      });

                    case 2:
                      onBlur();
                      event.eventCallback(this);

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));

          case "input":
            return froalaEvents["input"] = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 1);
                      });

                    case 2:
                      event.eventCallback(this);
                      onInputChange && onInputChange(this.html.get());

                    case 4:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this);
            }));

          default:
            return froalaEvents[event.eventName] = event.eventCallback;
        }
      });
    }

    return froalaEvents;
  }, [events, initEditor]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _classnames.default)("prmbl-richText", className, classes.root),
    ref: node
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    id: id,
    error: error,
    disabled: disabled,
    required: required,
    onClick: focusEditor,
    className: (0, _classnames.default)("prmbl-richTextLabel", classes.richtextLabel),
    shrink: true
  }, label), /*#__PURE__*/_react.default.createElement(_FroalaEditor.default, {
    id: "".concat(id, "-froala-editor"),
    tag: "textarea",
    model: value,
    onModelChange: onChangeHandler,
    config: _objectSpread({
      forceHtmlView: forceHtmlView,
      promptUserForAssetsAsync: promptUserForAssetsAsync,
      placeholderText: placeholder,
      toolbarSticky: toolbarSticky,
      charCounterCount: true,
      imagePaste: false,
      quickInsertButtons: quickInsertButtons,
      toolbarButtons: toolbarButtons,
      toolbarButtonsSM: toolbarButtonsSM,
      toolbarButtonsXS: toolbarButtonsXS,
      imageInsertButtons: ["imageByURL", "imageManager"],
      videoInsertButtons: ["videoByURL", "videoEmbed"],
      key: "iTB2xB6C1C4B1E2C1wd1DBKSPF1WKTUCQOa1OURPJ1KDe2F-11D2C2D2I2C3B3C1D6C1A1==",
      events: setEvents(disabled, onBlur, onInputChange),
      htmlAllowedTags: allowedHtmlTags,
      scrollableContainer: scrollableContainer,
      linkEditButtons: ["linkOpen", "linkEdit", "linkRemove"],
      linkInsertButtons: ["linkBack"],
      customToolbarButtons: customToolbarButtons,
      quickInsertEnabled: quickInsertEnabled,
      paragraphFormat: {
        N: "Normal",
        H1: "Heading 1",
        H2: "Heading 2",
        H3: "Heading 3",
        PRE: "Code"
      },
      imageStyles: {
        "fr-rounded": "Rounded",
        "fr-bordered": "Bordered"
      }
    }, config)
  }), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
    id: id,
    helperText: helperText,
    error: error,
    disabled: disabled,
    errorMessage: errorMessage
  }), secondaryHelperText && /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
    id: "".concat(id, "-disclaimer-helper-text"),
    helperText: secondaryHelperText
  }));
};

RichText.propTypes = {
  /**
   * The html tags allowed in the editor
   */
  allowedHtmlTags: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * The name of the event and the function to fire on that event.
   *
   * A full list of Froala events can be found at the following link: https://www.froala.com/wysiwyg-editor/docs/events
   */
  events: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The name of the Froala event to add the callback to.
     */
    eventName: _propTypes.default.string,

    /**
     * The function to execute on Froala event trigger.
     *
     * Signature: function = (editor) => {}
     */
    eventCallback: _propTypes.default.func
  })),

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.string,

  /**
   * If set shows a second set of helper text.
   */
  secondaryHelperText: _propTypes.default.string,

  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.  `function(value: string) => void`
   *
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   *  Callback fired when content in the editor has changed (every keystroke).
   *  This is different from onChange, which only executes upon losing focus on the editor.
   * `function(content : string) => void`
   *
   */
  onInputChange: _propTypes.default.func,

  /**
   * Callback fired when an asset is needed from the user. `(options: {imagesOnly:bool, allowMultiple: bool}) => [asset...]`
   */
  promptUserForAssetsAsync: _propTypes.default.func,

  /**
   * Callback fired when focus is lost. `function(event, editor) => void`
   *
   */
  onBlur: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value
   */
  placeholder: _propTypes.default.string,

  /**
   * An array of quick action buttons required.
   * Reference for all available optins:
   * https://www.froala.com/wysiwyg-editor/docs/options#quickInsertButtons
   */
  quickInsertButtons: _propTypes.default.array,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * Sets the container in which the editor popups are added.
   */
  scrollableContainer: _propTypes.default.string,

  /**
   * An object or array of buttons required:
   * Reference for all available optins:
   * https://www.froala.com/wysiwyg-editor/docs/options#toolbarButtons
   *
   * Object Example:
   *
   * 			{
   *				'moreText': {
   *			 			'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize',
   *									 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
   *						'align': 'right',
   *  	 			  'buttonsVisible': 2
   *						},
   * 				'moreParagraph': {
   *   				'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL',
   * 							 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
   * 					'align': 'right',
   *  	 			'buttonsVisible': 2
   * 					},
   * 				 'moreRich': {
   *   					'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters',
   * 									 'embedly', 'insertFile', 'insertHR'],
   * 						'align': 'right',
   *  	 				'buttonsVisible': 2
   * 						},
   * 					'moreMisc': {
   *  	 					'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
   *	   					'align': 'right',
   *  	 					'buttonsVisible': 2
   * 					}
   * 				}
   *
   * Additional plugins available from CivicPlus:
   *
   * - cpLang
   * - cpQuote
   * - insertAbbr
   * - cpDocument => Insert Asset Link using HCMS.
   */
  toolbarButtons: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),

  /**
   * An object or array of buttons required:
   * Reference for all available optins:
   * https://www.froala.com/wysiwyg-editor/docs/options#toolbarButtons
   *
   * Object Example:
   *
   * 			{
   *				'moreText': {
   *			 			'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize',
   *									 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
   *						'align': 'right',
   *  	 			  'buttonsVisible': 2
   *						},
   * 				'moreParagraph': {
   *   				'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL',
   * 							 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
   * 					'align': 'right',
   *  	 			'buttonsVisible': 2
   * 					},
   * 				 'moreRich': {
   *   					'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters',
   * 									 'embedly', 'insertFile', 'insertHR'],
   * 						'align': 'right',
   *  	 				'buttonsVisible': 2
   * 						},
   * 					'moreMisc': {
   *  	 					'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
   *	   					'align': 'right',
   *  	 					'buttonsVisible': 2
   * 					}
   * 				}
   *
   * Additional plugins available from CivicPlus:
   *
   * - cpLang
   * - cpQuote
   * - insertAbbr
   * - cpDocument => Insert Asset Link using HCMS.
   */
  toolbarButtonsSM: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),

  /**
   * An object or array of buttons required:
   * Reference for all available optins:
   * https://www.froala.com/wysiwyg-editor/docs/options#toolbarButtons
   *
   * Object Example:
   *
   * 			{
   *				'moreText': {
   *			 			'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize',
   *									 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
   *						'align': 'right',
   *  	 			  'buttonsVisible': 2
   *						},
   * 				'moreParagraph': {
   *   				'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL',
   * 							 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
   * 					'align': 'right',
   *  	 			'buttonsVisible': 2
   * 					},
   * 				 'moreRich': {
   *   					'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters',
   * 									 'embedly', 'insertFile', 'insertHR'],
   * 						'align': 'right',
   *  	 				'buttonsVisible': 2
   * 						},
   * 					'moreMisc': {
   *  	 					'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
   *	   					'align': 'right',
   *  	 					'buttonsVisible': 2
   * 					}
   * 				}
   *
   * Additional plugins available from CivicPlus:
   *
   * - cpLang
   * - cpQuote
   * - insertAbbr
   * - cpDocument => Insert Asset Link using HCMS.
   */
  toolbarButtonsXS: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),

  /**
   * Keeps the toolbar at the top of the editing box in basic mode.
   * Disabling this option, will keep the toolbar at the top of the page when scrolling down.
   */
  toolbarSticky: _propTypes.default.bool,

  /**
   * If true, the quickInsert menu will show.
   */
  quickInsertEnabled: _propTypes.default.bool,

  /**
   * The value of the element.
   */
  value: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Pass in custom toolbar buttons that you have made. They must have been registered with the name passed in.
   */
  customToolbarButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Name of the button to be made. This is what will be added to the toolbar.
     */
    name: _propTypes.default.string,

    /**
     * Icon of the toolbar button to be made.
     */
    icon: _propTypes.default.string,

    /**
     * Name of the button to be made. This is what will be added to the toolbar.
     */
    title: _propTypes.default.string,

    /**
     * Name of the button to be made. This is what will be added to the toolbar.
     */
    callback: _propTypes.default.func,

    /**
     * If true, the button will be added to edit image buttons.
     */
    isEditImage: _propTypes.default.bool
  })),

  /**
   * Custom Froala Editor configuration to initialize the editor with.
   * This configuration will overwrite any default configuration that have the same name.
   */
  config: _propTypes.default.object,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,
  forceHtmlView: _propTypes.default.bool
};

var _default = (0, _styles.withStyles)(_styles2.styles)(RichText);

exports.default = _default;